import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "¿Olvidaste tu contraseña?"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, " Ingresa tu correo institucional para enviarte una nueva contraseña. ")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Correo Institucional", -1)
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_9 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Enviar ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Espera por favor... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.onSubmitForgotPassword,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "email",
            name: "email",
            autocomplete: "off",
            modelValue: _ctx.emailForm.correo_electronico,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailForm.correo_electronico) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: { name: 'sign-in' },
            class: "btn btn-lg btn-secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("button", _hoisted_9, _hoisted_12, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}